import React from 'react';
import PropTypes from 'prop-types';
import {Label, InputGroup, InputGroupAddon, Input, Button} from 'reactstrap';
import moment from 'moment';

const NOT_SKIPPED = 'Not skipped';

class PickupSkipView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.incrementDecrement = this.incrementDecrement.bind(this);
    this.done = this.done.bind(this);
    this.hasValueChanged = this.hasValueChanged.bind(this);

    let {run, pickup} = props;
    this.state = {
      run,
      pickup,
      skippedPeriods: 0,
      skippedUntil: pickup.skippedUntil ? moment(pickup.skippedUntil).format('LT') : NOT_SKIPPED,
      skippedUntilDate: pickup.skippedUntil,
    };
  }

  componentWillReceiveProps(nextProps) {
    let {run, pickup} = nextProps;
    let currentPickup = this.state.pickup;
    if(JSON.stringify(pickup) !== JSON.stringify(currentPickup)){
      let skippedUntil = pickup.skippedUntil ? moment(pickup.skippedUntil).format('LT') : NOT_SKIPPED;
      this.setState({
        run,
        pickup,
        skippedUntil,
        skippedPeriods: 0,
        skippedUntilDate: pickup.skippedUntil
      });
    }
  }

  incrementDecrement(evnt,value) {
    evnt.preventDefault();
    let {skippedPeriods, pickup} = this.state;
    skippedPeriods = skippedPeriods + value;

    let skippedUntil = moment(pickup.skippedUntil ? pickup.skippedUntil : undefined).add(skippedPeriods * 15, 'm');

    if(skippedUntil.isSameOrBefore(moment())){
      skippedPeriods = 0;
      skippedUntil = null;
    }

    this.setState({
      skippedPeriods,
      skippedUntil: skippedUntil == null ? NOT_SKIPPED : skippedUntil.format('LT'),
      skippedUntilDate: skippedUntil
    });
  }

  done(evnt){
    if(evnt){
      evnt.preventDefault();
    }
    let {skippedUntilDate, pickup, run} = this.state;
    let updatedPickup = null;

    let updatedRun = {...run, pickups: [...run.pickups.map(x => {
      let returnVal = {...x};
      if(returnVal.id == pickup.id){
        returnVal.skippedUntil =  skippedUntilDate == null ? null : skippedUntilDate.format();
        updatedPickup = {...returnVal};
      }
      return returnVal;
    })]};

    this.props.onFinished(updatedRun);
    this.setState({
      skippedPeriods: 0,
      skippedUntil: skippedUntilDate == null ? NOT_SKIPPED : skippedUntilDate.format('LT'),
      skippedUntilDate,
      pickup: updatedPickup,
    });
  }

  hasValueChanged(){
    let sameMomment = moment(this.state.pickup.skippedUntil).isSame(this.state.skippedUntilDate);
    if(this.state.skippedUntilDate != null && this.state.pickup.skippedUntil==null){
      return true;
    }
    if(this.state.skippedUntilDate == null && this.state.pickup.skippedUntil!=null){
      return true;
    }
    return this.state.skippedUntilDate != null && !sameMomment;
  }

  render(){
    let unSkipped = this.state.run.pickups.filter(y => !y.isBase && y.pickupStatusCode == 'PEN').reduce((a,b)=>{
        return b.skippedUntil == null ? a + 1 : a;
    }, 0);
    if(unSkipped <= 1 && this.state.pickup.skippedUntil == null){
      return (<div>Can't skip all pickups</div>);
    }

    return (
    <div className="form-horizontal">
      <div className="form-group row">
        <div className="col-12" style={{marginTop: '5px'}}>
          <InputGroup>
            <InputGroupAddon addonType={'append'}>
              <Button color="secondary" onClick={(evnt) => this.incrementDecrement(evnt, -1)}><i className="fa fa-minus" />
              </Button>
            </InputGroupAddon>
            <Input disabled={true} value={this.state.skippedUntil} />
            <InputGroupAddon addonType={'append'}>
              <Button color="secondary" onClick={(evnt) => this.incrementDecrement(evnt, 1)}>
                <i className="fa fa-plus" />
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </div>
        { this.hasValueChanged() &&
        <div className="col-md-4" style={{marginTop: '5px'}}>
          <Button color="primary" onClick={this.done}><i className="fa fa-check" /></Button>
        </div>}
      </div>
    </div>);
  }
}

PickupSkipView.propTypes = {
  pickup: PropTypes.object.isRequired,
  run: PropTypes.object.isRequired,
  onFinished: PropTypes.func.isRequired,
};

export default PickupSkipView;